import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import { CassemsPreset } from './theme/cassems-preset'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
// tokens antes do style.css: o global consome as variáveis definidas aqui.
import './assets/tokens.css'
import './assets/style.css'

import App from './App.vue'
import router from './router'
import './plugins/axios'
import { localePtBr } from './plugins/primevue-locale'
import { keycloakService } from './services/keycloak.service'

const renderizarApp = () => {
  const app = createApp(App)
  app.use(createPinia())
  app.use(router)
  app.use(PrimeVue, {
    theme: { preset: CassemsPreset, options: { darkModeSelector: false } },
    // Equivale ao <default-locale>pt_BR</default-locale> do faces-config do legado.
    locale: localePtBr
  })
  app.use(ToastService)
  app.use(ConfirmationService)
  app.directive('tooltip', Tooltip)
  app.mount('#app')
}

// Inicializa o Keycloak antes de montar o Vue
keycloakService.initKeycloak(renderizarApp)
